'use strict';

/**
 * Component for the set selection
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Collection = require('base/Colido.Collection');
var LayoutView = require('base/Colido.LayoutView');
var SelectSetOverlayLayout = require('modules/collection/modules/set/views/layout/select-set-overlay');

var template = require('../../../templates/components/detail/field-sets.hbs');

var SetsComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'component-' + _.camelToHyphen(field.type);
    },

    ui: {
        'buttonAddToSet': '[data-action="add-to-set"]',
    },

    events: {
        'click @ui.buttonAddToSet': 'onActionAddToSet',
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },

        sets: function() {
            return this.model.getSets();
        },

        catalog: function() {
            return this.model.collection.catalog;
        },
    },

    onActionAddToSet: function() {
        App.addModal(new SelectSetOverlayLayout({
            model: this.model,
            collection: this.model.collection,
        }), {
            additionalClassName: 'modal-left modal-medium modal-select-set',
            onAfterClose: function(data) {
                if (data) {
                    App.radio('collection').execute(
                        'add:to:set',
                        this.model,
                        data.setModel
                    );
                }
            }.bind(this),
        });
    },

    hasValue: function() {
        return true;
    },
});

module.exports = SetsComponent;